import styled from "styled-components";
import { colors, font, radius, shadow } from "../../styles/theme/tokens";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-width: 820px;
`;

export const Filters = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Filter = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: ${radius.pill};
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 700;
  color: ${(props) => (props.$active ? "#FFFFFF" : colors.ink)};
  background: ${(props) => (props.$active ? colors.brand : colors.surface)};
  border: 1.5px solid ${(props) => (props.$active ? colors.brand : colors.line)};
  cursor: pointer;

  span {
    font-weight: 800;
    opacity: ${(props) => (props.$active ? 0.85 : 0.5)};
  }
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TableRow = styled.li`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-radius: ${radius.md};
  background: ${colors.surface};
  border: 1px solid ${colors.line};
  box-shadow: ${shadow.card};
  opacity: ${(props) => (props.$learned ? 0.75 : 1)};
`;

export const Words = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`;

export const Word = styled.span`
  font-family: ${font.text};
  font-size: 17px;
  font-weight: 800;
  color: ${colors.ink};
  overflow-wrap: anywhere;
`;

export const Translation = styled.span`
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 500;
  color: ${colors.muted};
  overflow-wrap: anywhere;
`;

export const StatusLabel = styled.span`
  flex-shrink: 0;
  padding: 5px 10px;
  border-radius: ${radius.pill};
  font-family: ${font.text};
  font-size: 12px;
  font-weight: 700;
  color: ${(props) => (props.$learned ? colors.success : colors.brandDeep)};
  background: ${(props) => (props.$learned ? colors.successSoft : colors.brandSoft)};

  @media (max-width: 480px) {
    display: none;
  }
`;

export const ActionGroup = styled.div`
  display: flex;
  gap: 6px;
  flex-shrink: 0;
`;

const VARIANTS = {
  learned: { color: colors.success, hover: colors.successSoft },
  new: { color: colors.brandDeep, hover: colors.brandSoft },
  delete: { color: colors.muted, hover: colors.dangerSoft, hoverColor: colors.danger },
};

export const ActionButton = styled.button`
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  border-radius: ${radius.sm};
  color: ${(props) => VARIANTS[props.$variant].color};
  background: ${colors.bg};
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: ${(props) => VARIANTS[props.$variant].hover};
    color: ${(props) => VARIANTS[props.$variant].hoverColor || VARIANTS[props.$variant].color};
  }
`;

export const Empty = styled.p`
  max-width: 820px;
  padding: 28px 20px;
  border-radius: ${radius.lg};
  border: 1.5px dashed ${colors.line};
  font-family: ${font.text};
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  color: ${colors.muted};
`;

// Лишилось від таблиці — експортуємо для сумісності
export const Table = Wrapper;
